export default {
  Main: {
    Title: "Danh sách đối soát",
    SearchFilter: "Tên | MST, MNS | Mã đơn vị",
  },
  List: {
    TransactionDate: "Ngày giao dịch",
    SettlementDate: "Ngày đối soát",
    TransactionSuccess: "Giao dịch thành công kì này",
    TransactionPrevious: "Giao dịch thành công kì trước chưa đối soát",
    TransactionOnHold: "Giao dịch chờ xử lý",
    AmountDeduct: "Số tiền bù trừ",
    Fee: "Phí (2c)",
    TotalFee: "Tổng phí <br> (9) = (2c)",
    //AmountPayToMerchant : "Số tiền thanh toán </br> cho ĐVCNTT",
    AmountPayToMerchant: "<p>Tổng tiền thanh toán <br/> (1) = (2b) - (9) <p>",
    StatusSettlement: "Trạng thái chờ đối soát",
    StatusPayment: "Trạng thái đối soát",
    PaymentPeriodDate: "Ngày dự kiến thanh toán",
    PaymentDate: "Ngày thanh toán",
    Quantity: "Số lượng",
    Value: "Giá trị",
    GroupTransTransHold: "Số tiền JETPAY tạm giữ",
    TotalQuantityTransHold: "Số lượng GD tạm giữ",
    TotalAmountTransHold: "Giá trị GD tạm giữ",
    TotalQuantityDeduct: "Số lượng GD bù trừ",
    TotalAmountDeduct: "Giá trị GD bù trừ (7)",
    BankName: "Ngân hàng",
    ControlReportDate: "Ngày đối soát",
    StatusConfirmData: "Trạng thái đối soát",
    TransactionTime: "Kỳ đối soát", // from - to
    // PaymentPeriodDate: "Kỳ thanh toán",
    GroupTransSuccess: "GD thành công kỳ này",
    TotalQuantityTransSuccess: `Số lượng <span class="color-secondary-neutral">(2a)</span>`,
    TotalAmountTransSuccess: `Giá trị <span class="color-secondary-neutral">(2b)</span>`,
    TotalFeeAmountTransSuccess: `Phí <span class="color-secondary-neutral">(2c)</span>`,
    GroupTransRefund: "Giao dịch hoàn trả",
    TotalQuantityTransRefund: `Số lượng <span class="color-secondary-neutral">(3a)</span>`,
    TotalAmountTransRefund: `Giá trị <span class="color-secondary-neutral">(3b)</span>`,
    TotalFeeAmountTransRefund: `Phí <span class="color-secondary-neutral">(3c)</span>`,
    GroupTransSuccessPrevious: "Giao dịch thành công kỳ trước chưa đối soát",
    TotalQuantityTransSuccessPrevious: `Số lượng <span class="color-secondary-neutral">(4a)</span>`,
    TotalAmountTransSuccessPrevious: `Giá trị <span class="color-secondary-neutral">(4b)</span>`,
    TotalFeeAmountTransSuccessPrevious: `Phí <span class="color-secondary-neutral">(4c)</span>`,
    TotalQuantityDeduct: `Số lượng GD <br/> bù trừ <span class="color-secondary-neutral">(8a)</span>`,
    TotalAmountDeduct: `Giá trị GD <br/> bù trừ <span class="color-secondary-neutral">(8b)</span>`,
    TotalQuantityNotEnoughMoney: `Số lượng GD <br/> không có tiền về <span class="color-secondary-neutral">(9a)</span>`,
    TotalAmountNotEnoughMoney: `Giá trị GD <br/> không có tiền về <span class="color-secondary-neutral">(9b)</span>`,
    GroupTransDeduct: "Số tiền bù trừ trong tổng thanh toán kỳ này",
    GroupTransOnHold: "GD khiếu nại, gian lận, nghi ngờ gian lận",
    TotalFeeAmount: `<p style="text-align:center">Tổng phí<br/><span class="color-secondary-neutral">(10) = (2c) + (3c) + (4c)</span><p>`,
    TotalJetpaypayToMerchant: `<p style="text-align:center">Số tiền thanh toán cho ĐVCNTT <br/><span class="color-secondary-neutral">(1) = (2b) - (3b) + (4b) - (8b) - (10)</span><p>`,
    TotalQuantityTransHold: `Số lượng GD <br/> tạm giữ <span class="color-secondary-neutral">(7a)</span>`,
    TotalAmountTransHold: `Giá trị GD <br/> tạm giữ <span class="color-secondary-neutral">(7b)</span>`,
    GroupTransTransHold: "Số tiền JETPAY tạm giữ (6b)",
    TotalQuantityGroupHoldAndDeduct: `<p style="text-align:center">Tổng số lượng<br/><span class="color-secondary-neutral">(5) = (7a) +(8a) + (9a)</span><p>`,
    TotalAmountGroupHoldAndDeduct: `<p style="text-align:center">Tổng giá trị<br/><span class="color-secondary-neutral">(6) = (7b) + (8b) + (9b)</span><p>`,
  },
};
